/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { style } from 'typestyle';

export function readinessChecklistStyles(themedColors: any) {
  return {
    common: {
      backdrop: style({
        fontFamily: "Segoe UI",
        backgroundColor: themedColors.background,
        borderRadius: '0px'
      }),
      header: style({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingBottom: '16px',
        marginTop: '27px',
        flexWrap: 'wrap',
        $nest: {
          'h1': {
            margin: '0',
          }
        }
      }),
      title: style({
        color: themedColors.mainTitleColor,
        fontSize: '18px',
        fontWeight: 'bold',
        letterSpacing: '0px',
        paddingLeft: '16px',
        paddingRight: '20px',
      }),
      progressIndicator: style({
        width: '200px',
      }),
      reset: style({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: '15px',
        cursor: 'pointer',
        color: themedColors.panelValidationResultPrintColor,
        fontSize: '14px',
        letterSpacing: '0px',
      }),
      print: style({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: '15px',
        cursor: 'pointer',
        color: themedColors.panelValidationResultPrintColor,
        fontSize: '14px',
        letterSpacing: '0px',
      })
    },
    divider: style({
      height: '1px',
      background: themedColors.dividerColor,
      borderRadius: '0px'
    }),
    checklist: {
      common: style({
        display: 'flex',
        flexDirection: 'column',
        color: themedColors.panelChecklistColor,
      }),
      bottomText: style({
        fontSize: '14px',
        letterSpacing: '0px',
        lineHeight: '20px',
        padding: '11px 23px',
      }),
      row: {
        common: style({
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '10px 20px',
          fontSize: '14px',
        }),
        colFirst: style({
          flexGrow: 1.5,
          letterSpacing: '0px',
          display: 'flex',
          flexDirection: 'row',
        }),
        lineThrough: style({
          textDecoration: 'line-through'
        }),
        link: style({
          color: themedColors.checklistLinkColor,
          textDecoration: 'none',
          fontSize: '14px',
          $nest: {
            '&:hover': {
              color: themedColors.checklistLinkColor,
              textDecoration: 'none',
            },
            '&:focus': {
              outline: "2px solid black"
            }
          },
        }),
      }
    }
  }
}
